/**
 * 描画コアが返すエラー。API のエラーコード(@signa/shared)とは別系統で、
 * ビューアの表示判断に使う。
 */
export const RENDERER_ERROR_CODES = {
    /** WebGL2 に対応していない。背景と枠の輪郭のみ表示する。 */
    UNSUPPORTED: 'UNSUPPORTED',
    /** コンテキストロストから復帰できなかった。 */
    RENDER_FAILED: 'RENDER_FAILED',
    /** 背景画像を取得できない(変換中の可能性)。 */
    BACKGROUND_PENDING: 'BACKGROUND_PENDING',
};
//# sourceMappingURL=types.js.map